export default __webpack_public_path__ + "static/media/10_SchererGruppe-DTM-Documentary-EschweilerPhotography_21A3629.f491b5a3.jpg";